import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DataTablesRequest, ModelSearch } from 'projects/ProjetoBaseAngular/domain/models';
import { OptionSearchType, SearchType } from 'projects/ProjetoBaseAngular/domain/types';
import { BaseCrudComponent } from 'projects/ProjetoBaseAngular/app/base-crud.component';
import { TypesService } from 'projects/admin/src/domain/services';
import { MetaMsgTemplateComponentModel } from '../../../domain/models';
import { MetaMsgTemplateComponentType } from '../../../domain/types';
import { MetaMsgTemplateComponentService } from '../../../domain/services/meta-msg-template-component.service';
import { MetaMsgTemplateComponentModalComponent } from './msg-template-component-modal/msg-template-component-modal.component';
import { MetaMsgTemplateParametroOrigemGrupos } from 'projects/admin/src/domain/consts';

@Component({
  selector: 'app-meta-msg-template-component',
  templateUrl: './msg-template-component.component.html'
})
export class MetaMsgTemplateComponentComponent extends BaseCrudComponent<MetaMsgTemplateComponentModel> implements OnInit {
  @ViewChild('modal') modal: MetaMsgTemplateComponentModalComponent;

  @Input('metaMsgTemplateId') metaMsgTemplateId: string;
  @Input() templateConfirmacaoPresenca = false;
  @Output() autoSave: EventEmitter<any> = new EventEmitter<any>();

  searchMetaMsgTemplateId = new ModelSearch('metaMsgTemplateId', OptionSearchType.Equals, SearchType.Guid);

  selectColumns = [
    { data: 'order' },
    { data: 'tipo' },
    { data: 'format' },
    { data: 'text' },
    { data: 'exampleJson' }
  ];

  constructor(
    injector: Injector,
    readonly service: MetaMsgTemplateComponentService,
    readonly typesService: TypesService
  ) {
    super(injector, service);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  beforeDtRequest(dataTablesParameters: DataTablesRequest) {
    const searches = [];

    this.searchMetaMsgTemplateId.searchTerm = this.metaMsgTemplateId;
    searches.push(this.searchMetaMsgTemplateId);

    dataTablesParameters.searches = searches;

    return super.beforeDtRequest(dataTablesParameters);
  }

  create() {
    this.autoSave.emit();
    super.create();
  }

  getParametrosOrigemPendente(): string[] {
    if (!this.templateConfirmacaoPresenca) {
      return [];
    }

    const origensSuportadas = MetaMsgTemplateParametroOrigemGrupos
      .reduce((result, grupo) => result.concat(grupo.opcoes.map(opcao => opcao.valor)), [] as string[]);

    return (this.models || [])
      .filter(component => component.tipo === MetaMsgTemplateComponentType.Header
        || component.tipo === MetaMsgTemplateComponentType.Body)
      .reduce((result, component) => result.concat((component.parametros || [])
        .filter(parametro => !origensSuportadas.includes(parametro.origem))
        .map(parametro => parametro.nome)), [] as string[]);
  }
}
